import React, { useContext, useState, useEffect } from "react";

export const DataContext = React.createContext();
export const useData = () => useContext(DataContext);
export const DataProvider = ({
  children
}) => {
  let [counts, setCounts] = useState(localStorage.getItem("counts") ? JSON.parse(localStorage.getItem("counts")) : {});
  let [countHistory, setCountHistory] = useState(localStorage.getItem("countsHistory") ? JSON.parse(localStorage.getItem("countsHistory")) : [[], []]);

  const addCount = (itemName, amt) => {
    if (!amt || !itemName) return;
    countHistory[0].push({ [itemName]: counts[itemName] || 0 });
    const current = counts[itemName] || 0;
    setCounts({ ...counts, [itemName]: current + parseFloat(amt) });
    setCountHistory([...countHistory]);
  }

  const undo = () => {
    if (countHistory[0].length === 0) return;

    const action = countHistory[0].pop();

    const redo = {};
    const newCounts = {...counts};

    for (let itemName of Object.keys(action)) {
      redo[itemName] = counts[itemName];
      newCounts[itemName] = action[itemName];
    }
    
    countHistory[1].push(redo);
    setCounts(newCounts);
    setCountHistory([...countHistory]);
  }

  const redo = () => {
    if (countHistory[1].length === 0) return;

    const action = countHistory[1].pop();

    const undo = {};
    const newCounts = {...counts};

    for (let itemName of Object.keys(action)) {
      undo[itemName] = counts[itemName];
      newCounts[itemName] = action[itemName];
    }

    countHistory[0].push(undo);
    setCounts(newCounts);
    setCountHistory([...countHistory]);
  }

  const clear = () => {
    const undo = {};
    Object.keys(counts).forEach(itemName => {
      if (counts[itemName] > 0)
        undo[itemName] = counts[itemName];
    })
    if (Object.keys(undo).length !== 0) {
      countHistory[0].push(undo);
      countHistory[1] = [];
    }
    const newCounts = {};
    for (let item of Object.keys(counts)) {
      newCounts[item] = 0;
    }
    setCounts({ ...counts, ...newCounts });
    setCountHistory([...countHistory]);
  }

  useEffect(() => {
    localStorage.setItem("counts", JSON.stringify(counts));
  }, [counts]);

  useEffect(() => {
    if (countHistory[0].length > 50)
      countHistory[0].shift()
    if (countHistory[1].length > 50)
      countHistory[1].shift()

    localStorage.setItem("countsHistory", JSON.stringify(countHistory));
  }, [countHistory]);

  return (
    <DataContext.Provider
      value={{
        addCount,
        undo,
        redo,
        clear,
        counts,
        countHistory
      }}
    >
      {children}
    </DataContext.Provider>
  )
}